import * as Types from '../../../.cache/__types__/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreatePortalLinkMutationVariables = Types.Exact<{
  input: Types.CreatePortalLinkInput;
}>;


export type CreatePortalLinkMutation = { __typename?: 'Mutation', createPortalLink?: { __typename?: 'CreatePortalLinkPayload', portal_url?: string | null } | null };

export type CreateCheckoutSessionMutationVariables = Types.Exact<{
  input: Types.CreateCheckoutSessionInput;
}>;


export type CreateCheckoutSessionMutation = { __typename?: 'Mutation', createCheckoutSession?: { __typename?: 'CreateCheckoutSessionPayload', checkout_url?: string | null } | null };

export type CreateResubscribeCheckoutSessionMutationVariables = Types.Exact<{
  input: Types.CreateResubscribeCheckoutSessionInput;
}>;


export type CreateResubscribeCheckoutSessionMutation = { __typename?: 'Mutation', createResubscribeCheckoutSession?: { __typename?: 'CreateResubscribeCheckoutSessionPayload', checkout_url?: string | null } | null };

export type CancelSubscriptionMutationVariables = Types.Exact<{
  input: Types.CancelSubscriptionInput;
}>;


export type CancelSubscriptionMutation = { __typename?: 'Mutation', cancelSubscription?: { __typename?: 'CancelSubscriptionPayload', current_period_end?: any | null, cancel_at_period_end?: boolean | null } | null };


export const CreatePortalLinkDocument = gql`
    mutation CreatePortalLink($input: CreatePortalLinkInput!) {
  createPortalLink(input: $input) {
    portal_url
  }
}
    `;
export type CreatePortalLinkMutationFn = Apollo.MutationFunction<CreatePortalLinkMutation, CreatePortalLinkMutationVariables>;

/**
 * __useCreatePortalLinkMutation__
 *
 * To run a mutation, you first call `useCreatePortalLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePortalLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPortalLinkMutation, { data, loading, error }] = useCreatePortalLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePortalLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreatePortalLinkMutation, CreatePortalLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePortalLinkMutation, CreatePortalLinkMutationVariables>(CreatePortalLinkDocument, options);
      }
export type CreatePortalLinkMutationHookResult = ReturnType<typeof useCreatePortalLinkMutation>;
export type CreatePortalLinkMutationResult = Apollo.MutationResult<CreatePortalLinkMutation>;
export type CreatePortalLinkMutationOptions = Apollo.BaseMutationOptions<CreatePortalLinkMutation, CreatePortalLinkMutationVariables>;
export const CreateCheckoutSessionDocument = gql`
    mutation CreateCheckoutSession($input: CreateCheckoutSessionInput!) {
  createCheckoutSession(input: $input) {
    checkout_url
  }
}
    `;
export type CreateCheckoutSessionMutationFn = Apollo.MutationFunction<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>;

/**
 * __useCreateCheckoutSessionMutation__
 *
 * To run a mutation, you first call `useCreateCheckoutSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckoutSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckoutSessionMutation, { data, loading, error }] = useCreateCheckoutSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCheckoutSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>(CreateCheckoutSessionDocument, options);
      }
export type CreateCheckoutSessionMutationHookResult = ReturnType<typeof useCreateCheckoutSessionMutation>;
export type CreateCheckoutSessionMutationResult = Apollo.MutationResult<CreateCheckoutSessionMutation>;
export type CreateCheckoutSessionMutationOptions = Apollo.BaseMutationOptions<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>;
export const CreateResubscribeCheckoutSessionDocument = gql`
    mutation CreateResubscribeCheckoutSession($input: CreateResubscribeCheckoutSessionInput!) {
  createResubscribeCheckoutSession(input: $input) {
    checkout_url
  }
}
    `;
export type CreateResubscribeCheckoutSessionMutationFn = Apollo.MutationFunction<CreateResubscribeCheckoutSessionMutation, CreateResubscribeCheckoutSessionMutationVariables>;

/**
 * __useCreateResubscribeCheckoutSessionMutation__
 *
 * To run a mutation, you first call `useCreateResubscribeCheckoutSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResubscribeCheckoutSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResubscribeCheckoutSessionMutation, { data, loading, error }] = useCreateResubscribeCheckoutSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateResubscribeCheckoutSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateResubscribeCheckoutSessionMutation, CreateResubscribeCheckoutSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateResubscribeCheckoutSessionMutation, CreateResubscribeCheckoutSessionMutationVariables>(CreateResubscribeCheckoutSessionDocument, options);
      }
export type CreateResubscribeCheckoutSessionMutationHookResult = ReturnType<typeof useCreateResubscribeCheckoutSessionMutation>;
export type CreateResubscribeCheckoutSessionMutationResult = Apollo.MutationResult<CreateResubscribeCheckoutSessionMutation>;
export type CreateResubscribeCheckoutSessionMutationOptions = Apollo.BaseMutationOptions<CreateResubscribeCheckoutSessionMutation, CreateResubscribeCheckoutSessionMutationVariables>;
export const CancelSubscriptionDocument = gql`
    mutation CancelSubscription($input: CancelSubscriptionInput!) {
  cancelSubscription(input: $input) {
    current_period_end
    cancel_at_period_end
  }
}
    `;
export type CancelSubscriptionMutationFn = Apollo.MutationFunction<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>(CancelSubscriptionDocument, options);
      }
export type CancelSubscriptionMutationHookResult = ReturnType<typeof useCancelSubscriptionMutation>;
export type CancelSubscriptionMutationResult = Apollo.MutationResult<CancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;